import { CheckIcon, WarningTwoIcon } from '@chakra-ui/icons';
import { Flex, Icon, Spinner, Text } from '@chakra-ui/react';

/*
 * A single step row in the Create Order progress (2265).
 * state: 'done' | 'loading' | 'pending' | 'error'
 */
export default function OrderStep({ label, state, darkMode }) {
    const palette = {
        done: { bg: 'green.50', circle: 'green.500', text: 'green.700' },
        loading: { bg: 'green.50', circle: 'green.500', text: 'green.700' },
        pending: {
            bg: darkMode ? 'whiteAlpha.100' : 'gray.50',
            circle: darkMode ? 'gray.600' : 'gray.300',
            text: darkMode ? 'gray.400' : 'gray.400',
        },
        error: { bg: 'red.50', circle: 'red.500', text: 'red.600' },
    }[state];

    return (
        <Flex
            align="center"
            gap={3}
            bg={palette.bg}
            borderRadius="md"
            px={4}
            py={3}>
            <Flex
                align="center"
                justify="center"
                boxSize="26px"
                borderRadius="full"
                bg={palette.circle}
                flexShrink={0}>
                {state === 'loading' ? (
                    <Spinner size="xs" color="white" />
                ) : state === 'error' ? (
                    <Icon as={WarningTwoIcon} color="white" boxSize="12px" />
                ) : state === 'done' ? (
                    <Icon as={CheckIcon} color="white" boxSize="12px" />
                ) : null}
            </Flex>
            <Text fontWeight="medium" fontSize="sm" color={palette.text}>
                {label}
            </Text>
        </Flex>
    );
}
